import script from "./MarketProduitsFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketProduitsFormView.vue?vue&type=script&setup=true&lang=ts"

import "./MarketProduitsFormView.vue?vue&type=style&index=0&id=f2661d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2661d8c"]])

export default __exports__